import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-title-modal',
  templateUrl: './title-modal.component.html',
  styleUrls: ['./title-modal.component.css']
})
export class TitleModalComponent implements OnInit {

  @Input('img') img: string = '';
  @Input('text') text: string = '';
  @Input('subtitle') subtitle: string = '';

  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// D:/GITHUB/F210/V18/rec_ng_renta210v18/src/app/components/title-modal/title-modal.component.ts